interface GeoCoords {
  lat: number;
  lng: number;
}

export function getCurrentLocation(
  options: PositionOptions = { enableHighAccuracy: true, timeout: 5000 }
): Promise<GeoCoords> {
  return new Promise<GeoCoords>((resolve) => {
    if (!navigator.geolocation) {
      resolve({ lat: 0, lng: 0 });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      () => {
        resolve({ lat: 0, lng: 0 });
      },
      options
    );
  });
}
